// Runtime <head> injection for PWA discovery tags. We can't put these in
// web/index.html as plain <link> tags because Bun's HTML walker tries to
// resolve absolute paths like `/icons/favicon-32.png` as build-time imports
// and fails (the icons live under public/ and are runtime-served). Injecting
// from JS keeps the references off Bun's resolution path; the browser still
// honors `<link rel="manifest|icon|apple-touch-icon">` and
// `<meta name="theme-color|apple-mobile-web-app-*">` when added dynamically.
//
// Cost: a single ~50ms post-load delay before the favicon swaps from the
// browser default to ours. Manifest-driven install affordance still works.

interface LinkSpec {
  rel: string;
  href: string;
  type?: string;
  sizes?: string;
}

interface MetaSpec {
  name: string;
  content: string;
}

const LINKS: LinkSpec[] = [
  { rel: "manifest", href: "/manifest.webmanifest" },
  { rel: "icon", type: "image/png", sizes: "32x32", href: "/icons/favicon-32.png" },
  { rel: "icon", type: "image/png", sizes: "16x16", href: "/icons/favicon-16.png" },
  { rel: "apple-touch-icon", href: "/icons/apple-touch-icon.png" },
];

const METAS: MetaSpec[] = [
  { name: "theme-color", content: "#FCFAF5" },
  { name: "apple-mobile-web-app-capable", content: "yes" },
  { name: "apple-mobile-web-app-status-bar-style", content: "default" },
  { name: "apple-mobile-web-app-title", content: "Glutenless" },
];

export function injectPwaMeta(): void {
  if (typeof document === "undefined") return;
  for (const spec of LINKS) {
    const link = document.createElement("link");
    link.rel = spec.rel;
    link.href = spec.href;
    if (spec.type) link.type = spec.type;
    if (spec.sizes) link.setAttribute("sizes", spec.sizes);
    document.head.appendChild(link);
  }
  for (const spec of METAS) {
    const meta = document.createElement("meta");
    meta.name = spec.name;
    meta.content = spec.content;
    document.head.appendChild(meta);
  }
}
